import {Component, OnInit} from '@angular/core';

import {URL_API} from '../constante';
import {Inscricao} from "../inscricao/inscricao";
import {InscricaoService} from "../inscricao/inscricao.service";
import {InscricaoDetailComponent} from "../inscricao-detail/inscricao-detail.component";

@Component({
  selector: 'app-inscricao-edit',
  templateUrl: '../inscricao/inscricao.component.html',
  styleUrls: ['./inscricao-edit.component.css'],
  providers: [InscricaoService]
})
export class InscricaoEditComponent extends InscricaoDetailComponent implements OnInit {

  ngOnInit() {
		if (!this.islogged()) {
            this.router.navigateByUrl('acesso');
        } else {
			let id: number;
			this.route.params.subscribe(params => id = +params['id']);
			this.inscricaoService.getInscricao(id).then(dados => this.setInscricao(dados));
			this.edit = true;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/inscricao-edit/inscricao-edit.component.ts